import React, { CSSProperties } from 'react';

import { Label } from './styles';
import Text from '../text';

interface IProps {
  style?: CSSProperties;
}

const LabelEmptyData: React.FC<IProps> = ({ style, children }) => {
  return (
    <Text className='!text-[.75rem] !text-[rgba(68,75,86,.42)]' style={style}>
      {children}
    </Text>
  )
}

export default LabelEmptyData;